<template>
  <div class="container privacy-important">
    <div class="row pt-4 pt-lg-5 pb-4">
      <div class="col-12 offset-md-4 col-md-4 text-center">
        <img class="img-question" src="../assets/privacy_important.svg" alt="icon">
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t("privacy.title")}}
        </label>
      </div>
    </div>
    <div class="row pt-3">
      <div class="offset-0 col-12 offset-lg-2 col-lg-8 text-center info">
        <label>
          {{ $t('privacy.info') }}
        </label>
      </div>
    </div>
    <div class="row pt-lg-1">
      <div class="col-12 text-center">
        <a class="privacy" @click="termsAndConditions">
          {{  $t('whoAreYou.termsAndConditions') }}
        </a>
      </div>
    </div>
    <div class="row pt-1 pt-lg-1">
      <div class="col-12 text-center">
        <a class="privacy" @click="privacyPolicy">
          {{  $t('whoAreYou.privacyPolicy') }}
        </a>
      </div>
    </div>
    <div class="row pt-2 pt-lg-5">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.start') }}
        </button>
      </div>
    </div>
    <div class="row pt-5 fixed-bottom">
      <div class="col-12 offset-lg-1 col-lg-10 text-center text-muted copyright">
        <label>
          {{ $t('privacy.copyright') }}
        </label>
        <label class="cursor-pointer" @click="termsAndConditions">
          {{ $t('privacy.terms') }}
        </label>
        {{ $t('privacy.and') }}
        <label class="cursor-pointer" @click="privacyPolicy">
          {{ $t('privacy.privacy') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    next () {
      this.$router.push({
        name: 'gender'
      })
    },
    privacyPolicy () {
      window.open('https://dadmin.bowheadhealth.com/info/pp/en_privacy_policy.html', '_blank')
    },
    termsAndConditions () {
      window.open('https://dadmin.bowheadhealth.com/info/tc/en_conditions.html', '_blank')
    }
  },
  mounted () {
    this.$store.dispatch('getLocation')
  }
}
</script>

<style>
.privacy-important .img-question {
  width: 100%;
  height: 34vh;
}

.privacy-important .title {
  font-weight: 700;
  font-size: 1.6rem;
}

.privacy-important .info {
  font-size: 1.1rem;
}

.privacy-important .privacy {
  color: #2bb1c4 !important;
  text-decoration: underline;
  font-size: .8rem;
  cursor: pointer;
}

.privacy-important .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: bold;
  border-radius: 15px;
}

.privacy-important .copyright {
  font-weight: 300;
  font-size: .6rem;
}

.privacy-important .cursor-pointer {
  cursor: pointer;
}

@media screen and (device-aspect-ratio: 40/71) {
  .privacy-important .img-question {
    width: 100%;
    height: 24vh;
  }

  .privacy-important .title {
    font-size: 1.7rem;
  }

  .privacy-important .info {
    font-size: .75rem;
  }

  .privacy-important .next {
    width: 80%;
    min-height: 70px;
    background-color: #2bb1c4;
    border-radius: 15px;
  }

  .privacy-important .copyright {
    font-weight: 300;
    font-size: .6rem;
  }
}
</style>
